<script setup lang="ts">
import {ref, watchEffect} from "vue";
import {RouterLink} from "vue-router";
import {Avatar, Drawer} from "@/Components/Library";

const props = defineProps<{
    group: any;
}>();
const emit = defineEmits(["hide"]);

const visible = ref(false);

const handleHide = () => {
    emit("hide");
    visible.value = false;
};

watchEffect(() => {
    if (props.group) {
        visible.value = true;
    }
});
</script>
<template>
    <Drawer
        v-model:visible="visible"
        header=" "
        position="bottom"
        @hide="handleHide"
        class="relative max-h-screen max-w-3xl overflow-y-auto"
    >
        <div v-if="group" class="flex flex-col gap-6 pb-12">
            <RouterLink :to="{name: 'feed', params: {group: group.id}}" @click="handleHide">
                <div class="flex flex-col items-center gap-4">
                    <Avatar
                        class="h-16 w-16 text-3xl"
                        :class="[`bg-${group?.color}`, group?.color?.class === 'white' ? 'text-black' : 'text-white']"
                        :image="group?.icon?.url"
                        :label="group?.icon?.url ? undefined : group.initials"
                    />
                    <h2 class="text-xl font-bold sm:text-3xl">{{ group.name }}</h2>
                </div>
            </RouterLink>
            <div class="flex flex-col gap-6">
                <div class="rounded-lg bg-stone-50 p-4">
                    <h3 class="mb-2 text-sm">Description</h3>
                    <p>{{ group.description }}</p>
                </div>
            </div>
        </div>
    </Drawer>
</template>
<style scoped></style>
